export default __webpack_public_path__ + "static/media/07_DAIF_SUSTAINABILITY_04.f1040011.mp4";